// extracted by mini-css-extract-plugin
export default {"root":"styles_root__Olcx7","title":"styles_title__2sKmY","filterRow":"styles_filterRow__U7PgC","note":"styles_note__3VL-6"};